<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="7000202">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="vehicleServiceBO.ajax?cmd=doQueryVehicleWaringList"
          :params="fullSearchData"
          bizName="车辆预警记录导出"
          bizCode="exp100099"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'plateNumber'"
                  @click="toCarDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-else>
                  <span>{{ scope.row[scope.column.property] }}</span>
                </section>
              </section>
            </el-table-column>
          </template>
          <el-table-column prop="control" label="操作" fixed="right">
            <template slot-scope="scope">
              <section>
                <qx-permpisions
                  permpisions="7000201"
                  v-if="scope.row.dealState == 1 && (scope.row.waringType < 6 || scope.row.waringType === 10 || scope.row.waringType === 11 ||scope.row.waringType===6)"
                >
                  <span class="primary cur" @click="deal(scope.row)"
                    >去处理</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  doQueryVehicleWaringList,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'plateNumber', label: '车牌号码', fixed: true },
          { prop: 'licenceTypeName', label: '牌照类型' },
          { prop: 'vehicleInfo', label: '车型' },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'userName', label: '归属员工' },
          { prop: 'driverUserName', label: '司机姓名' },
          { prop: 'driverUserTel', label: '司机手机' },
          { prop: 'waringTypeName', label: '预警类型' },
          { prop: 'waringDate', label: '预警开始时间' },
          // { prop: 'waringRemark', label: '预警内容' },
          { prop: 'busiEndDate', label: '到期时间' },
          { prop: 'dealStateName', label: '状态' },
          { prop: 'dealTime', label: '处理时间' },
          { prop: 'dealUserName', label: '处理人' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryVehicleWaringList,
    toCarDetail (item) {
      const type = 'detail';
      if (item.licenceType < 3) {
        this.jump({
          label: `查看车辆-${item.plateNumber}`,
          url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass || ''}&type=${type}`,
          full: true,
        });
      } else {
        this.jump({
          label: `查看挂车-${item.plateNumber}`,
          url: `/manage/car/trailer/archives/detail?id=${item.vehicleCode}&type=${type}`,
          full: true,
        });
      }

    },
    deal (item) {
      let waringType = item.waringType;
      if (waringType === 10) {
        waringType = 6;
      } else if (waringType === 11) {
        waringType = 7;
      }
      const query = `?certificatesInsuranceType=${waringType}&plateNumber=${encodeURI(item.plateNumber)}&waringId=${item.id}`;
      let url = '';
      let label = '';
      if (item.waringType === 0 || (item.waringType > 2 && item.waringType < 6) || item.waringType >= 10) {
        // 新增保险登记
        label = '新增保险登记';
        url = '/manage/car/maintain/insurance/edit' + query;
      } else if (item.waringType < 3) {
        // 新增证照登记
        label = '新增证照登记';
        url = '/manage/car/maintain/review/edit' + query;
      } else if (item.waringType === 6) {
        // 新增保养记录
        label = '新增保养记录';
        url = '/manage/car/maintain/maintenance/edit' + query;
      }
      this.jump({
        label,
        url,
        full: true,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
